/* Coverly Header — bar behaviour (search) and drawer behaviour (menu panels).

   The bar and the drawer are separate sections, because Shopify forbids mixing
   theme blocks with section-defined blocks in one section. The hamburger lives
   in the bar and the drawer lives elsewhere in the header group, so the two are
   wired together here by querying the document for [data-ch-drawer-root]. */
(function () {
  function drawerRoot() {
    return document.querySelector('[data-ch-drawer-root]');
  }

  /* ---------------- drawer ---------------- */
  function initDrawer(root) {
    if (root.dataset.chInit === 'true') return;
    root.dataset.chInit = 'true';

    var items = root.querySelectorAll('[data-ch-item]');
    var panels = root.querySelectorAll('[data-ch-panel]');

    function clearPanels() {
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      items.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-expanded', 'false');
      });
    }

    root.chClearPanels = clearPanels;

    root.chOpen = function () {
      root.classList.add('chd--open');
      document.body.classList.add('ch-locked');
      var first = root.querySelector('.ch__row');
      if (first) first.focus({ preventScroll: true });
    };

    root.chClose = function () {
      root.classList.remove('chd--open');
      document.body.classList.remove('ch-locked');
      clearPanels();
    };

    root.chIsOpen = function () { return root.classList.contains('chd--open'); };

    function resetToggles() {
      // The burger may be rendered twice (left for desktop, right for mobile).
      var toggles = document.querySelectorAll('[data-ch-toggle]');
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        t.setAttribute('aria-label', 'Open menu');
      });
      var visible = Array.prototype.filter.call(toggles, function (t) {
        return t.offsetParent !== null;
      })[0];
      if (visible) visible.focus({ preventScroll: true });
    }

    // A link pointing at the page you are already on would trigger a full reload
    // that looks like nothing happened. Closing the drawer is the useful answer.
    // Returns true when it handled the click, so callers can stop.
    function handleSamePage(href, e) {
      if (!href) return false;
      var url;
      try { url = new URL(href, window.location.href); } catch (err) { return false; }
      if (url.origin !== window.location.origin) return false;
      if (url.pathname !== window.location.pathname) return false;
      if (url.search !== window.location.search) return false;

      if (e) {
        // A real fragment still has somewhere to scroll to, so let the browser go.
        if (!url.hash) e.preventDefault();
      } else if (url.hash) {
        window.location.hash = url.hash;
      }
      root.chClose();
      resetToggles();
      return true;
    }

    root.addEventListener('click', function (e) {
      // Leave modified clicks, middle clicks and new-tab links to the browser.
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !root.contains(a)) return;
      if (a.target && a.target !== '_self') return;
      // The country picker's items are href="#" hooks driven by Dawn's own JS;
      // swallowing those clicks would break switching country.
      if (a.closest('.ch__country')) return;
      handleSamePage(a.getAttribute('href'), e);
    });

    root.querySelectorAll('[data-ch-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        root.chClose();
        resetToggles();
      });
    });

    // The sub-panel's own close button. On desktop the first column is still on
    // screen, so it should retreat to that rather than dismiss the whole menu;
    // on mobile the panel IS the menu, so there it closes everything.
    root.querySelectorAll('[data-ch-panel-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          clearPanels();
          return;
        }
        root.chClose();
        resetToggles();
      });
    });

    items.forEach(function (btn) {
      var id = btn.getAttribute('data-ch-target');
      var panel = root.querySelector('[data-ch-panel="' + id + '"]');
      var body = panel ? panel.querySelector('[data-ch-panel-body]') : null;
      // No nested blocks -> treat the row as a link rather than opening an empty panel.
      var empty = !body || body.children.length === 0;

      if (empty) {
        btn.classList.add('ch__row--nopanel');
        btn.setAttribute('aria-expanded', 'false');
        btn.removeAttribute('aria-controls');
      }

      btn.addEventListener('click', function () {
        if (empty) {
          var href = btn.getAttribute('data-ch-href');
          if (handleSamePage(href, null)) return;
          if (href) window.location.href = href;
          return;
        }
        var wasActive = btn.classList.contains('is-active');
        clearPanels();
        if (wasActive) return;
        panel.classList.add('is-active');
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    root.querySelectorAll('[data-ch-back]').forEach(function (el) {
      el.addEventListener('click', clearPanels);
    });
  }

  /* ---------------- header bar ---------------- */
  function initBar(root) {
    if (root.dataset.chInit === 'true') return;
    root.dataset.chInit = 'true';

    var toggles = root.querySelectorAll('[data-ch-toggle]');
    var searchPanel = root.querySelector('[data-ch-search]');
    var searchToggles = root.querySelectorAll('[data-ch-search-toggle]');
    var searchInput = root.querySelector('[data-ch-search-input]');
    var termsWrap = root.querySelector('[data-ch-terms]');

    function searchIsOpen() { return !!searchPanel && searchPanel.classList.contains('is-open'); }

    function openSearch() {
      if (!searchPanel) return;
      searchPanel.classList.add('is-open');
      searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      if (searchInput) searchInput.focus({ preventScroll: true });
    }

    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.classList.remove('is-open');
      searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    function syncTerms() {
      if (!termsWrap || !searchInput) return;
      termsWrap.classList.toggle('is-hidden', searchInput.value.trim().length > 0);
    }

    searchToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (searchIsOpen()) closeSearch(); else openSearch();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', syncTerms);
      syncTerms();
    }

    root.querySelectorAll('[data-ch-term]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        // Progressive enhancement: without JS the chip is a plain /search link.
        if (!searchInput) return;
        e.preventDefault();
        searchInput.value = chip.getAttribute('data-ch-term');
        searchInput.focus({ preventScroll: true });
        // SearchForm listens on a debounced 'input' event; this drives predictive results.
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        syncTerms();
      });
    });

    // The drawer is a different section and cannot read this one's settings, so
    // mirror the hamburger's edge onto it here unless the drawer opts out.
    (function syncDrawerSide() {
      var d = drawerRoot();
      if (!d || d.getAttribute('data-ch-side') !== 'auto') return;
      if (root.classList.contains('ch--burger-right')) d.classList.add('chd--right-mobile');
    })();

    function setToggleState(open) {
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var d = drawerRoot();
        if (!d || typeof d.chOpen !== 'function') return;
        if (d.chIsOpen()) {
          d.chClose();
          setToggleState(false);
        } else {
          closeSearch();
          d.chOpen();
          setToggleState(true);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (searchIsOpen()) { closeSearch(); return; }
      var d = drawerRoot();
      if (!d || typeof d.chIsOpen !== 'function' || !d.chIsOpen()) return;
      if (d.querySelector('[data-ch-panel].is-active')) {
        d.chClearPanels();
      } else {
        d.chClose();
        setToggleState(false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ch-drawer-root]').forEach(initDrawer);
    document.querySelectorAll('[data-ch-root]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', function (e) {
    var d = e.target.querySelector ? e.target.querySelector('[data-ch-drawer-root]') : null;
    if (d && typeof d.chOpen === 'function') d.chOpen();
  });
})();
